module.exports = [{
      plugin: require('../../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Infinity Labs Gallery","short_name":"Infinty Labs Gallery","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"browser","icon":"src/images/infinity.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"d9a6b84a69ce386e99343a91e4d737d1"},
    }]
